import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { xContext } from "../context/userContext";
import Footer from "./footer";

const Home = () => {
  const [amount, setAmount] = useState(1000);
  const [months, setMonths] = useState(1);
  const [installments, setInstallments] = useState(0);
  const [total, setTotal] = useState(0);
  const rate = 0.25;
  const ctx = useContext(xContext);

  useEffect(() => {
    ctx.updateAmount(amount);
    ctx.updateMonths(months);
  }, [amount, months]);

  const changeAmount = (value) => {
    setAmount(value);
    const total = rate * Number(value) + Number(value);
    setTotal(total);
    setInstallments(total / months);
  };

  const changeMonths = (month) => {
    setMonths(month);
    const total = rate * Number(amount) + Number(amount);
    setTotal(total);
    setInstallments(total / months);
  };

  return (
    <>
      {/* /.main-header */}
      <div className="stricky-header stricked-menu main-menu">
        <div className="sticky-header__content" />
        {/* /.sticky-header__content */}
      </div>
      {/* /.stricky-header */}
      <section className="main-slider">
        <div
          className="swiper-container thm-swiper__slider"
          data-swiper-options='{
            "slidesPerView": 1,
            "loop": true,
            "effect": "fade",
            "autoplay": {
                "delay": 5000
            },
            "navigation": {
                "nextEl": "#main-slider__swiper-button-next",
                "prevEl": "#main-slider__swiper-button-prev"
            }
          }'
        >
          <div className="swiper-wrapper">
            <div className="swiper-slide">
              <div
                className="image-layer"
                style={{
                  backgroundImage: "url(assets/images/cent.jpeg)",
                }}
              />

              <div className="container">
                <div className="row">
                  <div className="col-xl-6 col-lg-6">
                    <p>Simple & Secure Application Process</p>
                    <h2 style={{ color: "#A1D235" }}>Your Financial Friend</h2>

                    <a
                      className="thm-btn"
                      href="https://centuryloans.net/admin/apply.php"
                      style={{ marginLeft: "10px" }}
                    >
                      Apply For Loan
                    </a>

                    <Link className="thm-btn" to={"/contacts"}>
                      <a>Invest With Us</a>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="swiper-slide">
              <div
                className="image-layer"
                style={{
                  backgroundImage: "url(assets/images/backgrounds/woman2.jpg)",
                }}
              />

              <div className="container">
                <div className="row">
                  <div className="col-xl-6 col-lg-6">
                    <p>Simple & Secure Application Process</p>
                    <h2 style={{ color: "#A1D235" }}>Your Financial Friend</h2>

                    <a
                      className="thm-btn"
                      href="https://centuryloans.net/admin/apply.php"
                      style={{ marginRight: "10px" }}
                    >
                      Apply For Loan
                    </a>

                    <Link className="thm-btn" to={"/contacts"}>
                      <a>Invest With Us</a>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div id="calculator" className="col-lg-12 col-xl-5">
              <form
                action="#"
                id="loan-calculator"
                className="about-one__form wow fadeInUp"
                data-wow-duration="1500ms"
              >
                <h3>How Much Do You Need?</h3>
                <div className="about-one__form-content">
                  <div className="input-box__top">
                    <span>K1000</span>
                    <span>K{amount}</span>
                    <span>K50000</span>
                  </div>
                  {/* /.input-box__top */}
                  <div className="input-box">
                    <div
                      className="range-slider-count"
                      id="range-slider-count"
                    />
                    <input
                      type="hidden"
                      defaultValue=""
                      id="min-value-rangeslider-count"
                    />

                    <input
                      step={1000}
                      type="range"
                      className="form-control form-range"
                      defaultValue={1000}
                      min={1000}
                      max={50000}
                      onChange={(e) => changeAmount(e.target.value)}
                    />
                  </div>
                  {/* /.input-box */}
                  <div className="input-box__top">
                    <span>1 Month</span>
                  </div>
                  {/* /.input-box__top */}
                  <div className="input-box">
                    <div
                      className="range-slider-month"
                      id="range-slider-month"
                    />
                    <input
                      step={1}
                      type="range"
                      className="form-control form-range"
                      defaultValue={1}
                      min={1}
                      max={1}
                      onChange={(e) => changeMonths(e.target.value)}
                    />
                    <input
                      type="hidden"
                      defaultValue=""
                      id="max-value-rangeslider-month"
                    />
                  </div>

                  <div className="input-box__top">
                    <span>25%</span>
                  </div>

                  <div className="input-box">
                    <div
                      className="range-slider-interest"
                      id="range-slider-interest"
                    />
                    <input
                      type="hidden"
                      defaultValue=""
                      id="min-value-rangeslider-interest"
                    />
                    <input
                      type="hidden"
                      defaultValue=""
                      id="max-value-rangeslider-interest"
                    />
                  </div>
                  {/* /.input-box */}
                  <p>
                    <span>Pay Monthly</span>
                    <b>
                      K{installments}
                      <i id="loan-monthly-pay" />
                    </b>
                  </p>
                  <p>
                    <span>Total Pay Back</span>
                    <b>
                      K{total}
                      <i id="loan-total" />
                    </b>
                  </p>

                  <a
                    className="thm-btn"
                    href="https://centuryloans.net/admin/apply.php"
                    style={{ marginLeft: "10px" }}
                  >
                    Apply For Loan
                  </a>
                </div>
              </form>
            </div>
          </div>

          <div className="main-slider__nav">
            <div
              className="swiper-button-prev"
              id="main-slider__swiper-button-next"
            >
              <i className="pylon-icon-left-arrow" />
            </div>
            <div
              className="swiper-button-next"
              id="main-slider__swiper-button-prev"
            >
              <i className="pylon-icon-right-arrow" />
            </div>
          </div>

          {/* /.main-slider__nav */}
        </div>
        {/* /.swiper-container thm-swiper__slider */}
        <div className="feature-two">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div className="row">
                  <div
                    className="col-lg-6 col-md-6 wow fadeInUp"
                    data-wow-duration="1500ms"
                  >
                    <div className="feature-two__box">
                      <i className="pylon-icon-consumer-behavior" />
                      <p>Quick Application Process</p>
                    </div>
                    {/* /.feature-two__box */}
                  </div>
                  {/* /.col-lg-4 col-md-6 */}
                  <div
                    className="col-lg-6 col-md-6 wow fadeInUp"
                    data-wow-duration="1500ms"
                  >
                    <div className="feature-two__box">
                      <i className="pylon-icon-point-of-sale" />
                      <p>No Application Fees</p>
                    </div>
                    {/* /.feature-two__box */}
                  </div>
                  {/* /.col-lg-4 col-md-6 */}
                </div>
              </div>
            </div>
            {/* /.row */}
          </div>
          {/* /.container */}
        </div>
        {/* /.feature-two */}
      </section>
      {/* /.main-slider */}
      <section className="about-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-xl-7">
              <div className="about-one__content">
                <div className="block-title text-left">
                  <p>Company Introductions</p>
                  <h2>Our Statement of Commitment</h2>
                </div>
                {/* /.block-title */}
                <p>
                  We are strategically positioned to oﬀer comprehensive ﬁnancial
                  services to individuals and businesses. The focus of Century
                  Loans Limited is to form partnerships with its customers and
                  to provide the best loans possible by adding value through
                  excellence and quality services.
                </p>
              </div>
              {/* /.about-one__content */}
              <div className="row">
                <div className="col-md-6">
                  <div className="feature-four__box text-left">
                    {/* .feature-four__box */}
                    <div className="feature-four__box-inner">
                      <div className="feature-four__box-icon">
                        <i className="flaticon flaticon-property-1" />
                      </div>
                      <div className="feature-four__box-right">
                        <h3>Perfection</h3>
                        <p>Our Loan services are unmatched</p>
                      </div>
                    </div>
                  </div>
                  {/* /.feature-four__box */}
                </div>
                <div className="col-md-6">
                  <div className="feature-four__box text-left">
                    {/* .feature-four__box */}
                    <div className="feature-four__box-inner">
                      <div className="feature-four__box-icon">
                        <i className="flaticon flaticon-growth-1" />
                      </div>
                      <div className="feature-four__box-right">
                        <h3>Passion</h3>
                        <p>
                          About the business and the success of our clients.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* /.feature-four__box */}
                </div>
              </div>
            </div>
            {/* /.col-lg-6 */}
            <div id="calculator" className="col-lg-12 col-xl-5">
              <form
                action="#"
                id="loan-calculator"
                className="about-one__form wow fadeInUp"
                data-wow-duration="1500ms"
              >
                <h3>How Much Do You Need?</h3>
                <div className="about-one__form-content">
                  <div className="input-box__top">
                    <span>K1000</span>
                    <span>K{amount}</span>
                    <span>K50000</span>
                  </div>
                  {/* /.input-box__top */}
                  <div className="input-box">
                    <div
                      className="range-slider-count"
                      id="range-slider-count"
                    />
                    <input
                      type="hidden"
                      defaultValue=""
                      id="min-value-rangeslider-count"
                    />

                    <input
                      step={1000}
                      type="range"
                      className="form-control form-range"
                      defaultValue={1000}
                      min={1000}
                      max={50000}
                      onChange={(e) => changeAmount(e.target.value)}
                    />
                  </div>
                  {/* /.input-box */}
                  <div className="input-box__top">
                    <span>1 Month</span>
                  </div>
                  {/* /.input-box__top */}
                  <div className="input-box">
                    <div
                      className="range-slider-month"
                      id="range-slider-month"
                    />
                    <input
                      step={1}
                      type="range"
                      className="form-control form-range"
                      defaultValue={1}
                      min={1}
                      max={1}
                      onChange={(e) => changeMonths(e.target.value)}
                    />
                    <input
                      type="hidden"
                      defaultValue=""
                      id="max-value-rangeslider-month"
                    />
                  </div>

                  <div className="input-box__top">
                    <span>25%</span>
                  </div>

                  <div className="input-box">
                    <div
                      className="range-slider-interest"
                      id="range-slider-interest"
                    />
                    <input
                      type="hidden"
                      defaultValue=""
                      id="min-value-rangeslider-interest"
                    />
                    <input
                      type="hidden"
                      defaultValue=""
                      id="max-value-rangeslider-interest"
                    />
                  </div>
                  {/* /.input-box */}
                  <p>
                    <span>Pay Monthly</span>
                    <b>
                      K{installments}
                      <i id="loan-monthly-pay" />
                    </b>
                  </p>
                  <p>
                    <span>Total Pay Back</span>
                    <b>
                      K{total}
                      <i id="loan-total" />
                    </b>
                  </p>

                  <a
                    className="thm-btn"
                    href="https://centuryloans.net/admin/apply.php"
                    style={{ marginLeft: "10px" }}
                  >
                    Apply For Loan
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section id="services" className="service-one">
        <div className="container">
          <div className="block-title text-center">
            <p>What We’re Offering</p>
            <h2>Our Loans Services</h2>
          </div>
          {/* /.block-title */}
          <div className="row">
            <div className="col-lg-4">
              <div className="service-one__card">
                <div className="service-one__image">
                  <a href="">
                    <div className="post-thumbnail">
                      <img src="assets/images/services/personal.png" alt="" />
                    </div>
                  </a>
                </div>
                {/* /.service-one__image */}
                <div className="service-one__content">
                  <a href="">
                    <div className="service-icon">
                      <i className="flaticon-money" />
                    </div>
                  </a>
                  <h3>
                    <a href="#">Personal Loan</a>
                  </h3>
                  <p>
                    Borrow instantly to cover your personal bills, debt
                    consolidation, or unexpected expenses.
                  </p>
                  <a
                    href="#"
                    className="pylon-icon-right-arrow service-one__link"
                  />
                  {/* /.service-one__link */}
                </div>
                {/* /.service-one__content */}
              </div>
              {/* /.service-one__card */}
            </div>
            {/* /.col-lg-4 */}
            <div className="col-lg-4">
              <div className="service-one__card">
                <div className="service-one__image">
                  <a href="#">
                    <div className="post-thumbnail">
                      <img src="assets/images/services/emergency.png" alt="" />
                    </div>
                  </a>
                </div>
                {/* /.service-one__image */}
                <div className="service-one__content">
                  <a href="#">
                    <div className="service-icon">
                      <i className="flaticon-online-money" />
                    </div>
                  </a>
                  <h3>
                    <a href="#">Emergency Loan</a>
                  </h3>
                  <p>
                    Borrow instantly to cover your unplanned expenses. A car
                    breakdown, or emergency medical expenses.
                  </p>
                  <a
                    href="#"
                    className="pylon-icon-right-arrow service-one__link"
                  />
                  {/* /.service-one__link */}
                </div>
                {/* /.service-one__content */}
              </div>
              {/* /.service-one__card */}
            </div>
            {/* /.col-lg-4 */}
            <div className="col-lg-4">
              <div className="service-one__card">
                <div className="service-one__image">
                  <a href="#">
                    <div className="post-thumbnail">
                      <img src="assets/images/services/future.jpg" alt="" />
                    </div>
                  </a>
                </div>
                {/* /.service-one__image */}
                <div className="service-one__content">
                  <a href="#">
                    <div className="service-icon">
                      <i className="flaticon-property-1" />
                    </div>
                  </a>
                  <h3>
                    <a href="#">More Loans</a>
                  </h3>
                  <p>
                    Cash advances, Education loans, Agriculture loans, Vehicle
                    financing and Women business loans.
                  </p>
                  <a
                    href="#"
                    className="pylon-icon-right-arrow service-one__link"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-one">
        <img
          src="assets/images/shapes/feature-shape-1-1.png"
          alt=""
          className="feature-one__shape-1"
        />
        <img
          src="assets/images/shapes/feature-shape-1-2.png"
          alt=""
          className="feature-one__shape-2"
        />
        <img
          src="assets/images/shapes/feature-shape-1-3.png"
          alt=""
          className="feature-one__shape-3"
        />
        <div id="about" className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="block-title text-left">
                <p>Clientelle and Opportunities</p>
                <h2>Business Opportunity for you</h2>
              </div>
              {/* /.block-title */}
            </div>
            {/* /.col-lg-6 */}
            <div className="col-lg-6">
              <p className="block-text">
                Century Loans Limited has initiated an investment program
                intended at growing the business clientele and also support our
                clients through investments packages with a good return on
                investment. This opportunity is made to help individuals save
                and grow their ﬁnances.
              </p>
              {/* /.block-text */}
            </div>
            {/* /.col-lg-6 */}
          </div>
          {/* /.row */}
          <div className="row">
            <div className="col-lg-4">
              <div className="feature-one__box">
                <i className="pylon-icon-assets" />
                <p>Very Low Rates on All Loans</p>
              </div>
              {/* /.feature-one__box */}
            </div>
            {/* /.col-lg-4 */}
            <div className="col-lg-4">
              <div className="feature-one__box">
                <i className="pylon-icon-verification" />
                <p>99.9% Success Rate Guarantee</p>
              </div>
              {/* /.feature-one__box */}
            </div>
            {/* /.col-lg-4 */}
            <div className="col-lg-4">
              <div className="feature-one__box">
                <i className="pylon-icon-finance" />
                <p>Flexible with Your Repayments</p>
              </div>
              {/* /.feature-one__box */}
            </div>
            {/* /.col-lg-4 */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>
      {/* /.feature-one */}
      <section className="trusted-company">
        <div
          className="trusted-company__bg"
          style={{
            backgroundImage: "url(assets/images/shapes/trust-bg-1-1.png)",
          }}
        />
        {/* /.trusted-company__bg */}
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="trusted-company__content">
                <div className="block-title text-left">
                  <p>Integrity</p>
                  <h2>Most People Trust on Us For Fast Services</h2>
                </div>
                {/* /.block-title */}
                <div className="trusted-company__image">
                  <img
                    src="assets/images/services/quick.png"
                    alt=""
                    height={148}
                    width={171}
                  />
                  <p>
                    We stand on our strong principles of honesty and consistency
                    in all our opera ons. We do thorough due diligence to ensure
                    that we oﬀer you the best services. We abide by the law. We
                    honor our words with our ac ons. We avoid conﬂicts of
                    interests, we act fairly and maintain conﬁden ality.
                  </p>
                </div>
                {/* /.trusted-company__image */}
                <div className="row">
                  <div className="col-sm-5 col-xs-12">
                    <ul className="trusted-company__list">
                      <li className="trusted-company__list-item">
                        <span>
                          <i
                            aria-hidden="true"
                            className="far fa-check-circle"
                          />
                        </span>
                        <span className="trusted-company__list-text">
                          Emergency Loan
                        </span>
                      </li>
                      {/* /.trusted-company__list-item*/}
                      <li className="trusted-company__list-item">
                        <span>
                          <i
                            aria-hidden="true"
                            className="far fa-check-circle"
                          />
                        </span>
                        <span className="trusted-company__list-text">
                          Personal Loan
                        </span>
                      </li>
                      {/* /.trusted-company__list-item*/}
                      <li className="trusted-company__list-item">
                        <span>
                          <i
                            aria-hidden="true"
                            className="far fa-check-circle"
                          />
                        </span>
                        <span className="trusted-company__list-text">
                          Cash Advances
                        </span>
                      </li>

                      <li className="trusted-company__list-item">
                        <span>
                          <i
                            aria-hidden="true"
                            className="far fa-check-circle"
                          />
                        </span>
                        <span className="trusted-company__list-text">
                          Educational Loan
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="col-sm-6 col-xs-12">
                    <ul className="trusted-company__list trusted-company__list-2">
                      <li className="trusted-company__list-item">
                        <span>
                          <i
                            aria-hidden="true"
                            className="far fa-check-circle"
                          />
                        </span>
                        <span className="trusted-company__list-text">
                          Agriculture Loan
                        </span>
                      </li>

                      <li className="trusted-company__list-item">
                        <span>
                          <i
                            aria-hidden="true"
                            className="far fa-check-circle"
                          />
                        </span>
                        <span className="trusted-company__list-text">
                          Vehicle Financing
                        </span>
                      </li>

                      <li className="trusted-company__list-item">
                        <span>
                          <i
                            aria-hidden="true"
                            className="far fa-check-circle"
                          />
                        </span>
                        <span className="trusted-company__list-text">
                          Women Business Loans
                        </span>
                      </li>

                      <li className="trusted-company__list-item">
                        <span>
                          <i
                            aria-hidden="true"
                            className="far fa-check-circle"
                          />
                        </span>
                        <span className="trusted-company__list-text">
                          Invoice Discounting
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="trusted-company__box-wrap">
                <div className="trusted-company__box">
                  <span>1</span>
                  <p>
                    Easy loan solutions for small agency, business and companies
                  </p>
                </div>
                {/* /.trusted-company__box */}
                <div className="trusted-company__box">
                  <span>2</span>
                  <p>Submit Required Document and Details for loan approval </p>
                </div>
                {/* /.trusted-company__box */}
                <div className="trusted-company__box">
                  <span>3</span>
                  <p>Take our loans now and pay within the stipulated period</p>
                </div>
                {/* /.trusted-company__box */}
                <div className="trusted-company__box">
                  <span>4</span>
                  <p>
                    Get small loans for more needs in 2 hours with less
                    documents
                  </p>
                </div>
                {/* /.trusted-company__box */}
              </div>
              {/* /.trusted-company__box-wrap */}
            </div>
            {/* /.col-lg-6 */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>

      <section className="why-choose">
        <img
          src="assets/images/shapes/why-choose-shape-1-1.png"
          className="why-choose__shape-1"
          alt=""
        />
        <img
          src="assets/images/shapes/why-choose-shape-1-2.png"
          className="why-choose__shape-2"
          alt=""
        />
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="why-choose__image">
                <p>
                  <i className="pylon-icon-investment" />
                  Several years of working experience
                </p>
                <img src="assets/images/services/prof.png" alt="" />
              </div>
              {/* /.why-choose__image */}
            </div>
            {/* /.col-lg-6 */}
            <div className="col-lg-6">
              <div className="why-choose__content">
                <div className="block-title text-left">
                  <p>Our Benfits</p>
                  <h2>Why Choose Us?</h2>
                </div>
                {/* /.block-title */}
                <p>
                  Our long term vision is to become a compe ve and sustainable
                  company with the capacity for fulﬁlling clients' economic and
                  social needs and building reliable partnerships as we grow.
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <div className="why-choose__box">
                      <h3>
                        <i className="fa fa-caret-right" />
                        Perfection
                      </h3>
                      <p>Our Loan services are unmatched</p>
                    </div>
                    {/* /.why-choose__box */}
                  </div>
                  {/* /.col-md-6 */}
                  <div className="col-md-6">
                    <div className="why-choose__box">
                      <h3>
                        <i className="fa fa-caret-right" />
                        Passion
                      </h3>
                      <p>About the success of our clients.</p>
                    </div>
                    {/* /.why-choose__box */}
                  </div>
                  {/* /.col-md-6 */}
                </div>
                {/* /.row */}
                <div className="why-choose__progress">
                  <div className="why-choose__progress-top">
                    <h3>Loan Process</h3>
                    <span>90%</span>
                  </div>
                  {/* /.why-choose__progress-top */}
                  <div className="why-choose__progress-bar">
                    <span
                      style={{ width: "90%" }}
                      className="wow slideInLeft"
                      data-wow-duration="1500ms"
                    />
                  </div>
                  {/* /.why-choose__progress-bar */}
                </div>
                {/* /.why-choose__progress */}
                <div className="why-choose__progress">
                  <div className="why-choose__progress-top">
                    <h3>Consultancy</h3>
                    <span>80%</span>
                  </div>
                  {/* /.why-choose__progress-top */}
                  <div className="why-choose__progress-bar">
                    <span
                      style={{ width: "80%" }}
                      className="wow slideInLeft"
                      data-wow-duration="1500ms"
                    />
                  </div>
                  {/* /.why-choose__progress-bar */}
                </div>
                {/* /.why-choose__progress */}
                <div className="why-choose__progress">
                  <div className="why-choose__progress-top">
                    <h3>Payment Benefits</h3>
                    <span>85%</span>
                  </div>
                  {/* /.why-choose__progress-top */}
                  <div className="why-choose__progress-bar">
                    <span
                      style={{ width: "85%" }}
                      className="wow slideInLeft"
                      data-wow-duration="1500ms"
                    />
                  </div>
                  {/* /.why-choose__progress-bar */}
                </div>
                {/* /.why-choose__progress */}
              </div>
              {/* /.why-choose__content */}
            </div>
            {/* /.col-lg-6 */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>

      <Footer />

      <div className="bottom-footer">
        <div className="container">
          <p>© Copyright 2021 by Century Loans</p>

          {/* /.bottom-footer__social */}
        </div>
        {/* /.container */}
      </div>

      <div className="mobile-nav__wrapper">
        <div className="mobile-nav__overlay mobile-nav__toggler" />
        {/* /.mobile-nav__overlay */}
        <div className="mobile-nav__content">
          <span className="mobile-nav__close mobile-nav__toggler" />
          <div className="logo-box">
            <a href="#" aria-label="logo image">
              <img src="assets/images/logo-light.png" width={155} alt="" />
            </a>
          </div>
          {/* /.logo-box */}
          <div className="mobile-nav__container" />
          {/* /.mobile-nav__container */}
          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="pylon-icon-email1" />
              <a href="#">info@centuryloans</a>
            </li>
            <li>
              <i className="pylon-icon-telephone" />

              <a href="tel:+260772314242">+260772314242 / +260760665151</a>
            </li>
          </ul>
        </div>
      </div>

      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <i className="fa fa-angle-up" />
      </a>
    </>
  );
};

export default Home;
